module.exports = __webpack_public_path__ + "static/media/inspection-purco.efa88605.png";